import * as React from "react";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Form, Field, FormElement } from "@progress/kendo-react-form";
import { Input, Checkbox } from "@progress/kendo-react-inputs";
import { Label } from "@progress/kendo-react-labels";
import { MultiSelect } from "@progress/kendo-react-dropdowns";
import { useActiveApplications } from "services/applicationService";
import SubmitButton from "components/common/SubmitButton";

const AllowedAppsMultiSelect = (fieldRenderProps) => {
  const { value, onChange } = fieldRenderProps;
  const { data: activeApps } = useActiveApplications();
  const appsList = activeApps.map((app) => app.appCode);
  return (
    <div className="d-flex flex-column">
      <Label className="label mt-1 mb-2 w-100">Allowed Apps</Label>
      <MultiSelect
        data={appsList}
        value={value || []}
        onChange={(e) => onChange({ value: e.value })}
        style={{ padding: "0px", height: "50px" }}
      />
    </div>
  );
};

const EditFixedFeeHeader = ({ cancelEdit, onSubmit, isSubmitting, item }) => {
  const [submitAttempted, setSubmitAttempted] = React.useState(false);

  const validateForm = (values) => {
    const errors = {};
    if (!values.name || values.name.trim() === "") {
      errors.name = "Name is required";
    }
    if (!values.details || values.details.trim() === "") {
      errors.details = "Details are required";
    }
    if (!values.allowedApps || values.allowedApps.length === 0) {
      errors.allowedApps = "At least one app must be selected";
    }
    return errors;
  };

  return (
    <Dialog
      title={item ? `Edit ${item.name}` : "Add Template"}
      onClose={cancelEdit}
      width={600}
    >
      <Form
        onSubmit={onSubmit}
        initialValues={{
          active: true,
          ...item,
          allowedApps: item?.allowedApps
            ? typeof item.allowedApps === "string"
              ? item.allowedApps.split(",").filter(Boolean)
              : item.allowedApps
            : [],
        }}
        validator={validateForm}
        render={(formRenderProps) => (
          <>
            <div className="p-3 ps-4">
              <FormElement style={{ maxWidth: 1200 }}>
                <fieldset className="k-form-fieldset">
                  <div className="mb-2">
                    <Label className="label mt-1 mb-2 w-100">Name</Label>
                    <Field
                      name="name"
                      component={Input}
                      placeholder="Enter Name"
                    />
                    {submitAttempted && formRenderProps.errors?.name && (
                      <div className="fs-sm my-1 text-danger">
                        <i>{formRenderProps.errors.name}</i>
                      </div>
                    )}
                  </div>
                  <div className="mb-2">
                    <Label className="label mt-1 mb-2 w-100">Details</Label>
                    <Field
                      name="details"
                      component={Input}
                      placeholder="Enter Details"
                    />
                    {submitAttempted && formRenderProps.errors?.details && (
                      <div className="fs-sm my-1 text-danger">
                        <i>{formRenderProps.errors.details}</i>
                      </div>
                    )}
                  </div>
                  <div className="mb-3">
                    <Field
                      name="allowedApps"
                      component={AllowedAppsMultiSelect}
                    />
                    {submitAttempted && formRenderProps.errors?.allowedApps && (
                      <div className="fs-sm my-1 text-danger">
                        <i>{formRenderProps.errors.allowedApps}</i>
                      </div>
                    )}
                  </div>
                  <Field name="active" component={Checkbox} label="Active" />
                </fieldset>
              </FormElement>
            </div>
            <div className="dialog-footer">
              <button
                className="bgBtnSecondary common-btn me-2"
                onClick={cancelEdit}
                disabled={isSubmitting}
              >
                Cancel
              </button>
              <SubmitButton
                className="me-3"
                isLoading={isSubmitting}
                onClick={() => {
                  setSubmitAttempted(true);
                  formRenderProps.onSubmit();
                }}
                disabled={!formRenderProps.allowSubmit || isSubmitting}
              >
                {item ? "Update" : "Save"}
              </SubmitButton>
            </div>
          </>
        )}
      />
    </Dialog>
  );
};

export default EditFixedFeeHeader;
